import React, { useState,useEffect } from "react";

//import icons
import { MdOutlinePlumbing } from "react-icons/md";
import { BsLightningFill } from "react-icons/bs";
import { AiFillFormatPainter } from "react-icons/ai";








const TenantTable = ({ handleShowModal, setTenantData,expenses }) => {
  //expenses variables
  const [formattedExpenses, setFormattedExpenses] = useState([]);
 
  const formatExpenses = (expensesReceived) => {
    return expensesReceived.map((expense, index) => ({
      id: `T00${index + 1}`,
      expenseName: expense.type.charAt(0).toUpperCase() + expense.type.slice(1),
      dateMade: new Date(expense.date).toLocaleString('default', { month: 'long', year: 'numeric' }),
      apartmentNumber: expense.house.house_no || "N/A",
      apartmentName: expense.property.name || "N/A",
      expenseAmount: expense.amount.toString() || "N/A",
      expenseType: expense.type.charAt(0).toUpperCase() + expense.type.slice(1),
      expenseDescription: expense.description || "No description",
      profilePicture: "", // No profile picture
      extras: {
        createdAt: expense.createdAt,
        updatedAt: expense.updatedAt,
        version: expense.__v,
      },
    }));
  };

  useEffect(() => {
    if (expenses.length > 0) {
      setFormattedExpenses(formatExpenses(expenses));
    }
    console.log("Expenses", expenses.length);
  }, [expenses]);


  const [expandedRow, setExpandedRow] = useState(null);
  const [hover, setHover] = useState(false);

  const handleRowClick = (expenseId) => {
    setExpandedRow(expandedRow === expenseId ? null : expenseId);
  };

  const styles = {
    card: {
      width: "97%",
      display: "flex",
      justifyContent: "space-between",
      marginTop: "10px",
      backgroundColor: "white",
      boxShadow: "rgba(0, 0, 0, 0.28) 0px 0px 5px 0px",
      padding: "7px 15px",
      borderRadius: "10px",
      alignItems: "center",
      cursor: "pointer",
    },
    firstSection: {
      display: "flex",
      alignItems: "center",
      gap: "20px",
    },
    profilePicture: {
      width: "50px",
      height: "50px",
      borderRadius: "50%",
    },
    placeHolder: {
      width: "50px",
      height: "50px",
      borderRadius: "50%",
      backgroundColor: "#192A3A",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      color:"white"
    },
    dateMade: {
      color: "#9d9d9d",
      fontSize: "14px",
      fontFamily: "Karla, sans-serif",
      marginTop: "4px",
    },
    apartmentNumber: {
      color: "#B39359",
    },
    expandedContent: {
      width: "97%",
      margin: "20px 0px",
      padding: "1rem",
      backgroundColor: "rgb(255, 255, 255)",
      border: "1px solid rgb(221, 221, 221)",
      borderRadius: "5px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    expandedTitle: {
      color: "#192A3A",
      fontSize: "18px",
      fontWeight: "600",
      marginBottom: "10px",
      fontFamily: "Karla, sans-serif",
    },
    expandedRow: {
      display: "flex",
      justifyContent: "space-between",
      width: "40%",
      marginBottom: "10px",
    },
    expandedSubTitle: {
      fontSize: "16px",
      fontFamily: "Poppins,sans-serif",
      fontWeight: "200",
    },
    expandedDetails: {
      fontFamily: "Poppins,sans-serif",
      fontWeight: "400",
      fontSize: "16px",
    },
    button: {
      backgroundColor: hover ? "#B39359" : "#192A3A",
      color: "white",
      padding: "7px 10px",
      borderRadius: "5px",
      cursor: "pointer",
      marginTop: "10px",
      fontSize: "16px",
      fontWeight: "200",
      transition:"background-color 0.3s ease",
    },
  };

  return (
    <div>
      {formattedExpenses.map((expense) => (
        <>
          <div style={styles.card} onClick={() => handleRowClick(expense.id)}>
            <div style={styles.firstSection}>       
              <div style={styles.placeHolder}>
                {/* check expense type and select icon based on type */}

                {expense.expenseType === "Plumbing" ? <MdOutlinePlumbing fontSize={25}/> : null}
                {expense.expenseType === "Electricity" ? <BsLightningFill fontSize={25} /> : null}
                {expense.expenseType === "Painting" ? <AiFillFormatPainter  fontSize={25} /> : null}
                {expense.expenseType === "Sewer" ? <MdOutlinePlumbing fontSize={25} /> : null}
                {expense.expenseType === "Water" ? <MdOutlinePlumbing fontSize={25} /> : null}
                {expense.expenseType === "Other" ? <MdOutlinePlumbing fontSize={25} /> : null}
              
              </div>
              <div>
                <div>{expense.expenseName}</div>
                <div style={styles.dateMade}>{expense.dateMade}</div>
              </div>
            </div>
            <div> {expense.apartmentName}</div>
            <div style={styles.apartmentNumber}>{expense.apartmentNumber}</div>
          </div>
          {expandedRow === expense.id && (
            <div style={styles.expandedContent}>
              <div style={styles.expandedTitle}>Expense Details</div>
              <div style={styles.expandedRow}>
                <div style={styles.expandedSubTitle}>Expense Id:</div>{" "}
                <div style={styles.expandedDetails}>{expense.id}</div>
              </div>
              <div style={styles.expandedRow}>
                <div style={styles.expandedSubTitle}>Expense Amount:</div>{" "}
                <div style={styles.expandedDetails}>ksh. {expense.expenseAmount}</div>
              </div>
              <div style={styles.expandedRow}>
                <div style={styles.expandedSubTitle}>Expense Type:</div>{" "}
                <div style={styles.expandedDetails}>{expense.expenseType}</div>
              </div>
              <div style={styles.expandedRow}>
                <div style={styles.expandedSubTitle}>Expense Descripion:</div>{" "}
                <div style={styles.expandedDetails}>{expense.expenseDescription}</div>
              </div>
              
              <div style={styles.expandedRow}>
                <div style={styles.expandedSubTitle}>Apartment:</div>{" "}
                <div style={styles.expandedDetails}>{expense.apartmentName}</div>
              </div>
              <div
                style={styles.button}
                onClick={() => {
                  handleShowModal("modify expense");
                  setTenantData({
                    id: expense.id,
                    expenseName: expense.expenseName,
                    dateMade: expense.dateMade,
                    apartmentNumber: expense.apartmentNumber,
                    apartmentName: expense.apartmentName,
                    expenseType: expense.expenseType,
                    firstName: expense.expenseName.split(" ")[0],
                    lastName: expense.expenseName.split(" ")[1],
                    expenseAmount: "123-456-7890",
                    expenseDescription: expense.expenseDescription,
                  });
                }}
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
              >
                Edit Details
              </div>
            </div>
          )}
        </>
      ))}
    </div>
  );
};



export default TenantTable;
